// extracted by mini-css-extract-plugin
module.exports = {"linkBtnWrapper":"linkButton_linkBtnWrapper__1jNkl","linkBtn":"linkButton_linkBtn__2MPvV"};